/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import type { ChangeEvent } from 'react';
import { Archive, FileClock, Upload } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';

const NS = '/bff/v1/j05-s05-manter-recurso';

export function ManutencaoRecursosPage() {
  const [s, setS] = useState<any>();
  const [busy, setBusy] = useState(false);
  const [recursoId, setRecursoId] = useState('');
  const [tipo, setTipo] = useState<'NOVA_VERSAO' | 'INATIVACAO'>('NOVA_VERSAO');
  const [motivo, setMotivo] = useState('');
  const [vigencia, setVigencia] = useState('');
  const [arquivo, setArquivo] = useState<{ nome: string; base64: string }>();

  async function load() {
    const r = await chamarApi<any>(NS + '/state');
    setS(r.state);
    setRecursoId((atual) => atual || r.state.recursos[0]?.recursoId || '');
  }

  useEffect(() => {
    void load();
  }, []);

  function escolherArquivo(e: ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file) return setArquivo(undefined);
    const reader = new FileReader();
    reader.onload = () =>
      setArquivo({ nome: file.name, base64: String(reader.result).split(',')[1] ?? '' });
    reader.readAsDataURL(file);
  }

  async function submeter() {
    const recurso = s.recursos.find((item: any) => item.recursoId === recursoId);
    if (!recurso) return;
    setBusy(true);
    try {
      const r = await chamarApi<any>(NS + '/verbs/submeter', {
        metodo: 'POST',
        corpo: {
          recursoTipo: recurso.recursoTipo,
          recursoId,
          tipo,
          motivo,
          vigenciaFutura: vigencia,
          arquivoNome: tipo === 'NOVA_VERSAO' ? arquivo?.nome : undefined,
          arquivoBase64: tipo === 'NOVA_VERSAO' ? arquivo?.base64 : undefined,
          substituicaoPlanejada: tipo === 'NOVA_VERSAO',
          chaveIdempotencia: crypto.randomUUID(),
        },
      });
      setS(r.state);
    } finally {
      setBusy(false);
    }
  }

  if (!s)
    return (
      <main role="status" className="p-6">
        Carregando manutenção…
      </main>
    );
  return (
    <main className="min-w-0 space-y-5">
      <header>
        <h1 className="text-3xl font-semibold">{s.titulo}</h1>
        <p>{s.descricao}</p>
      </header>
      {s.alertas.map((a: any) => (
        <p role="alert" key={a.mensagem}>
          {a.mensagem}
        </p>
      ))}
      {s.fase === 'VAZIO' ? (
        <p>Nenhum recurso disponível para manutenção.</p>
      ) : (
        <form
          className="grid gap-4 rounded-md border p-4"
          onSubmit={(e) => {
            e.preventDefault();
            void submeter();
          }}
        >
          <label>
            Recurso
            <select
              className="block w-full rounded-md border bg-background p-2"
              value={recursoId}
              onChange={(e) => setRecursoId(e.target.value)}
            >
              {s.recursos.map((r: any) => (
                <option key={r.recursoId} value={r.recursoId}>
                  {r.identificacao} · {r.aptidao}
                </option>
              ))}
            </select>
          </label>
          <label>
            Alteração
            <select
              className="block w-full rounded-md border bg-background p-2"
              value={tipo}
              onChange={(e) => setTipo(e.target.value as any)}
            >
              <option value="NOVA_VERSAO">Nova versão documental</option>
              <option value="INATIVACAO">Inativação</option>
            </select>
          </label>
          <label>
            Motivo
            <textarea
              className="block w-full rounded-md border bg-background p-2"
              minLength={8}
              required
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
            />
          </label>
          <label>
            Vigência futura
            <input
              className="block w-full rounded-md border bg-background p-2"
              type="date"
              required
              value={vigencia}
              onChange={(e) => setVigencia(e.target.value)}
            />
          </label>
          {tipo === 'NOVA_VERSAO' && (
            <label>
              <Upload className="mr-2 inline h-4 w-4" />
              Documento
              <input className="block w-full" type="file" required onChange={escolherArquivo} />
            </label>
          )}
          <Button disabled={busy || !recursoId} type="submit">
            <Archive className="mr-2 h-4 w-4" />
            Enviar solicitação
          </Button>
        </form>
      )}
      <section className="space-y-3" aria-label="Histórico de solicitações">
        {s.solicitacoes.map((m: any) => (
          <article key={m.id} className="rounded-md border p-4">
            <h2 className="font-semibold">
              <FileClock className="mr-2 inline h-5 w-5" />
              {m.tipo} · {m.status}
            </h2>
            <p>Vigência: {m.vigenciaFutura}</p>
            <p>{m.motivo}</p>
          </article>
        ))}
      </section>
    </main>
  );
}
